import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RegisterApprovalPage } from './register-approval.page';

const routes: Routes = [
  {
    path: '',
    component: RegisterApprovalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RegisterApprovalPageRoutingModule {}
